"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportQuotes = exports.ExportQuotes = exports.ExportQuotesActionTypes = exports.QuotesActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var QuotesActionTypes = (0, _namespacedKeyMirror.default)({
  EXPORT_QUOTES: null
}, 'quotes');
exports.QuotesActionTypes = QuotesActionTypes;
var ExportQuotesActionTypes = (0, _actions.createRequestTypes)(QuotesActionTypes.EXPORT_QUOTES);
exports.ExportQuotesActionTypes = ExportQuotesActionTypes;
var ExportQuotes = (0, _actions.createRequestActions)(ExportQuotesActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportQuotesActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_react.default.createElement(_FormattedMessage.default, {
      message: "sales.quotes.export.success.message"
    })));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ExportQuotesActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_react.default.createElement(_FormattedMessage.default, {
      message: "sales.quotes.export.failure.message"
    })));
  }
});
exports.ExportQuotes = ExportQuotes;
var exportQuotes = (0, _fluxActions.createAction)(QuotesActionTypes.EXPORT_QUOTES);
exports.exportQuotes = exportQuotes;